import Vue from 'vue'

Vue.directive('sticky', {
  bind: function (el) {

    var stuckThreshold = 0
    var stuck = false

    window.addEventListener('scroll', function () {
      var coords = Vue.$utils.getCoords(el)
      if (!stuck) {
        stuckThreshold = coords.top
      }

      if (coords.scrollTop >= stuckThreshold && !stuck) {
        el.classList.add('stuck')
        stuck = true
      } else if (coords.scrollTop < stuckThreshold && stuck) {
        el.classList.remove('stuck')
        stuck = false
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/directives/sticky.js